"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { useTranslations } from "next-intl";
import { useShallow } from "zustand/react/shallow";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
import { getVolumeIcon, useVolumeStore } from "@/stores/use-volume-store";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuVolumeItem(t0) {
  const $ = _c(25);
  let isSheet;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = onClick;
    $[3] = rest;
  } else {
    isSheet = $[1];
    onClick = $[2];
    rest = $[3];
  }
  const {
    volume,
    toggleVolume
  } = useVolumeStore(useShallow(_temp));
  const [playSelect] = usePlaySound(Sound.Select);
  let t1;
  if ($[4] !== volume) {
    t1 = getVolumeIcon(volume);
    $[4] = volume;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const icon = t1;
  const t = useTranslations("MoreMenuVolumeItem");
  let t2;
  if ($[6] !== icon) {
    t2 = {
      icon
    };
    $[6] = icon;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const iconProps = t2;
  let t3;
  if ($[8] !== onClick || $[9] !== playSelect || $[10] !== toggleVolume) {
    t3 = e => {
      toggleVolume();
      playSelect();
      onClick?.(e);
    };
    $[8] = onClick;
    $[9] = playSelect;
    $[10] = toggleVolume;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== iconProps || $[13] !== isSheet) {
    t4 = isSheet ? <Button {...iconProps} size="lg" variant="secondary" /> : <MoreMenuItemAvatar {...iconProps} />;
    $[12] = iconProps;
    $[13] = isSheet;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t) {
    t5 = t("title");
    $[15] = t;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t5) {
    t6 = <MoreMenuItemContent><MoreMenuItemTitle>{t5}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== isSheet || $[20] !== rest || $[21] !== t3 || $[22] !== t4 || $[23] !== t6) {
    t7 = <MoreMenuItem isSheet={isSheet} onClick={t3} {...rest}>{t4}{t6}</MoreMenuItem>;
    $[19] = isSheet;
    $[20] = rest;
    $[21] = t3;
    $[22] = t4;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}
function _temp(state) {
  return {
    volume: state.volume,
    toggleVolume: state.toggleVolume
  };
}